import React from 'react';
import { Button, Popconfirm } from 'antd';
import { Edit, Trash2 } from 'lucide-react';
import { Error } from '@mui/icons-material';
import { CalendarActionButtonsProps } from '@/interfaces/ICalendarWorkflows';

export const CalendarActionButtons: React.FC<CalendarActionButtonsProps> = ({
	onEdit,
	onShowErrorLogs,
	onDelete,
	isDeleting,
}) => {
	return (
		<div className="flex items-center gap-2 ml-auto">
			<Button
				type="default"
				icon={<Edit size={16} />}
				onClick={onEdit}
				className="border-blue-300 text-blue-600 hover:bg-blue-50"
				loading={isDeleting}
				size="small"
			>
				Edit
			</Button>

			<Button
				type="default"
				icon={<Error />}
				onClick={onShowErrorLogs}
				className="border-orange-300 text-orange-600 hover:bg-orange-50"
				loading={isDeleting}
				size="small"
			>
				Errors
			</Button>

			<Popconfirm
				title="Delete Calendar Workflow"
				description="Are you sure you want to delete this calendar workflow?"
				onConfirm={onDelete}
				okText="Yes"
				cancelText="No"
				placement="left"
				okButtonProps={{ danger: true }}
			>
				<Button
					type="default"
					danger
					icon={<Trash2 size={16} />}
					className="border-red-300 text-red-600 hover:bg-red-50"
					loading={isDeleting}
					size="small"
				>
					Delete
				</Button>
			</Popconfirm>
		</div>
	);
};
